module.exports = __webpack_public_path__ + "img/event.44cdc6fb.svg";